export default __webpack_public_path__ + "static/banner1-140b6a0142a3a04944b85b178ac7cc16.jpg";